import React, { useState, useEffect, useRef } from 'react';
import { OIDCReactLib } from "@bnsf/oidc-token-lib-react";
import { AuthProvider } from './AuthContext';
import AppRoutes from './Routes';

const Root = () => {
  const [useLocalOIDC, setUseLocalOIDC] = useState();
  const fetchedRef = useRef(false);

  const oidcConfig =
  {
    "issuerURI": "https://idptr.bnsf.com",
    "callBackURI": "https://localhost:18732/authgrantflowredirect",
    "clientId": "HEqMofL0cAlh0stH2yja",
    "clientSecret": "3KymGEHN8FYpP05kNQX8",
    "scope": "openid profile localhost:8080 localhost",
  };

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const url = document.location.origin + '/config/baseUrl';
    fetch(url, { method: 'get' }).then(response => {
      if (response.ok) {
        return response.text();
      } else {
        console.error("Error determining base URL: " + response.status);
        throw response;
      }
    }).then(result => {
      if (result.startsWith("https://")) {
        setUseLocalOIDC(false);
      } else {
        setUseLocalOIDC(true);
      }
    });
  }, []);

  console.log("Use local OIDC: " + useLocalOIDC);

  if(useLocalOIDC===undefined) {
    return (<div />)
  } else {
    return (
      <>
        <nav className="navbar navbar-expand-lg navbar-dark bg-banner">
          <a className="navbar-brand">TeamConnect Tools</a>
        </nav>
        {useLocalOIDC == true ? <OIDCReactLib oauthConfig={oidcConfig} /> : <OIDCReactLib />}

        <AuthProvider>
          <AppRoutes />
        </AuthProvider>

      </>
    )
  }
}

export default Root;
